import { render } from "./IconBoxEmptyBlank.vue?vue&type=template&id=b27a35e4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__